export default "__VITE_ASSET__DEug8gHN__"